import { FanCognitoApiError } from '../../auth/fan-auth';

/**
 * Maps Cognito SDK error codes to i18n keys under `auth.errors.*`.
 * Codes not in the map fall through to the raw Cognito message —
 * usually English-readable enough to diagnose without ugly i18n keys.
 */
const CODE_TO_KEY: Record<string, string> = {
  NotAuthorizedException: 'auth.errors.notAuthorized',
  UserNotFoundException: 'auth.errors.userNotFound',
  UserNotConfirmedException: 'auth.errors.userNotConfirmed',
  UsernameExistsException: 'auth.errors.usernameExists',
  CodeMismatchException: 'auth.errors.codeMismatch',
  ExpiredCodeException: 'auth.errors.expiredCode',
  LimitExceededException: 'auth.errors.limitExceeded',
  InvalidPasswordException: 'auth.errors.invalidPassword',
  InvalidParameterException: 'auth.errors.invalidParameter',
};

/** Cognito wraps PreSignUp-lambda rejections as
 *  "PreSignUp failed with error <our message>." — strip the boilerplate
 *  so the fan sees just the human sentence (e.g. the「請直接用 Google
 *  登入」duplicate-account guard). */
function stripLambdaPrefix(message: string): string {
  const m = message.match(/^Pre[A-Za-z]+ failed with error (.+?)\.?$/);
  return m ? m[1] : message;
}

export function friendlyFanAuthError(
  err: unknown,
  t: (key: string) => string,
): string {
  if (err instanceof FanCognitoApiError) {
    const key = CODE_TO_KEY[err.code];
    if (key) return t(key);
    return stripLambdaPrefix(err.message) || t('auth.errors.unknown');
  }
  return err instanceof Error ? stripLambdaPrefix(err.message) : t('auth.errors.unknown');
}
